module.exports = __webpack_public_path__ + "static/media/lottery_event.f92a8d20.png";